import styled from 'styled-components'

export default styled.div`
  background-color: rgba(119, 121, 132, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`
